import { FC, useState, useRef, ChangeEvent } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faXmark } from "@fortawesome/free-solid-svg-icons";
import colors from "../../styles/colors";

const Container = styled.div`
    position: relative;
`;

const InputWrapper = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
`;

const SearchIcon = styled.span`
    position: absolute;
    left: 12px;
    color: rgba(255, 255, 255, 0.35);
    pointer-events: none;
    display: flex;
    align-items: center;

    svg {
        width: 13px;
        height: 13px;
    }
`;

const ClearButton = styled.button`
    position: absolute;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.4);
    cursor: pointer;
    padding: 2px;
    border-radius: 4px;
    transition: color 0.15s ease;

    &:hover {
        color: white;
    }

    svg {
        width: 12px;
        height: 12px;
    }
`;

const StyledInput = styled.input`
    width: 100%;
    padding: 8px 36px 8px 34px;
    font-size: 15px;
    color: white;
    background-color: ${colors.bgColorBlack2};
    border: 2px solid rgba(255, 255, 255, 0.15);
    border-radius: 6px;
    outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &::placeholder {
        color: rgba(255, 255, 255, 0.4);
    }

    &:focus {
        border-color: gold;
        box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.15);
    }
`;

interface SearchPpvProps {
    onFilterTextChange: (value: string) => void;
    className?: string;
    listPpv?: unknown[];
}

const SearchPpv: FC<SearchPpvProps> = (props) => {
    const [value, setValue] = useState('');
    const [searchTimeout, setSearchTimeout] = useState<NodeJS.Timeout | null>(null);
    const inputRef = useRef<HTMLInputElement>(null);

    function handleInputChange(e: ChangeEvent<HTMLInputElement>): void {
        const newValue = e.target.value;
        setValue(newValue);

        if (searchTimeout) {
            clearTimeout(searchTimeout);
            setSearchTimeout(null);
        }
        setSearchTimeout(setTimeout(() => {
            props.onFilterTextChange(newValue);
        }, 1000));
    }

    function handleClear(): void {
        setValue('');
        if (searchTimeout) {
            clearTimeout(searchTimeout);
            setSearchTimeout(null);
        }
        props.onFilterTextChange('');
        inputRef.current?.focus();
    }

    return (
        <Container className={`col-4 d-flex justify-content-center ${props.className ?? ''}`}>
            <InputWrapper>
                <SearchIcon>
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                </SearchIcon>

                <StyledInput
                    ref={inputRef}
                    type="text"
                    placeholder="Cerca"
                    value={value}
                    onChange={handleInputChange}
                />

                {value && (
                    <ClearButton onClick={handleClear} title="Cancella ricerca">
                        <FontAwesomeIcon icon={faXmark} />
                    </ClearButton>
                )}
            </InputWrapper>
        </Container>
    );
};

export default SearchPpv;
